import io from 'socket.io-client'
// import {wechatTeacherService} from './instance.js'
import {createNewGatwaySign, createNewGatwaySignWx} from '@/utils/getSignHeader.js'
import { wechatDomainQLAPP, wechatDomainQL } from './instance.js'

export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  ret = ret.slice(0, -1)
  return ret
}]

//获取直播室信息
export const getLiveRoom = async (params) => {
  // let headers = getSignHeader(params)
  // const res = await wechatTeacherService.get('/rjhy-minilive/api/v1/room/wechat/getRoomListByTeacherNo.json', {params, headers})
  // return res.data
  let headers = createNewGatwaySignWx(params, 'get')
  const res =  await wechatDomainQL.get(`/rjhy-minilive/api/v1/room/gw/getRoomListByTeacherNo.json`, { params, headers })
  return res.data
}

//获取直播室在线人数
export const getOnlineUser = async (params) => {
  // let headers = getSignHeader(params)
  // const res = await wechatTeacherService.get('/rjhy-minilive/api/v1/room/wechat/getOnlineUser.json', {params, headers})
  // return res.data
  let headers = createNewGatwaySignWx(params, 'get')
  const res =  await wechatDomainQL.get(`/rjhy-minilive/api/v1/room/gw/getOnlineUser.json`, { params, headers })
  return res.data
}

//获取老师详情
export const getTeacherInfo = async (params) => {
  // let headers = getSignHeader(params)
  // const res =  await wechatTeacherService.get('/rjhy-news/api/1/wechat/author/detail', {params, headers})
  // return res.data
  let headers = createNewGatwaySignWx(params, 'get')
  const res =  await wechatDomainQL.get(`/rjhy-news/api/1/gw/author/detail`, { params, headers })
  return res.data
}

// 获取socket地址
export const getSockIp = async () => {
  // const res =  await wechatTeacherService.get('/rjhy-minilive/api/v1/server/wechat/getWebAddr.json')
  // return res.data
  let headers = createNewGatwaySign({}, 'get')
  const res =  await wechatDomainQLAPP.get(`/rjhy-minilive/api/v1/server/gw/getWebAddr.json`, { params: {}, headers })
  return res.data
}

export const socketCon = (option, callback) => {
  let WSS_URI = 'wss:' + '//' + option.ip + ':' + option.port + '/client?roomNo=' + (option.roomNo).toUpperCase() + '&periodNo=' + (option.periodNo).toUpperCase()
  let broadcastSocket = io(WSS_URI)
  broadcastSocket.on('connect', function () {
    console.log('socket is connected ' + WSS_URI)
  })
  broadcastSocket.on('broadcast', function (data) {
    // console.log(data)
    callback(data)
  })
  broadcastSocket.on('disconnect', function () {
    // console.log('Socket disconnected')
  })
  broadcastSocket.on('error', function () {
    // console.log('Socket error')
  })
}

//获取活动banner列表
export const getActivityList = async (params, token) => {
  // let headers = getSignHeader(params)
  // const res =  await wechatTeacherService.get('/rjhy-activity-manage/api/v1/activities/pages', {params, headers})
  // return res.data
  let headers = createNewGatwaySign(params, 'get')
  headers.token = token
  const res =  await wechatDomainQLAPP.get(`/rjhy-activity-manage/api/v1/activities/pages`, { params, headers })
  return res.data
}
